// 获取订单支付信息
import { requestRaw, requestApi } from '../util/network'

// 商品的支付
export const pay_new =
  (paySn, payType, data, key, uniapp = 0, hash, img) =>
    requestApi(
      '/Memberpayment/pay_new',
      'POST',
      {
        'payType': payType,
        'pay_sn': paySn,
        'password': data.password,
        'rcb_pay': data.rcb_pay,
        'pd_pay': data.pd_pay,
        'payment_code': data.payment_code,
        'key': key,
        'uniapp': uniapp,
        'random_number': Math.random(),
        'hash': hash,
        'img': img,
      },
      'member'
    )
// 用户支付
export const pay =
  (paySn, payType, data, key, uniapp = 0, hash, img, inrAmount) =>
    requestApi(
      '/Memberpayment/pd_pay',
      'POST',
      {
        'payType': payType,
        'pay_sn': paySn,
        'password': data.password,
        'rcb_pay': data.rcb_pay,
        'pd_pay': data.pd_pay,
        'payment_code': data.payment_code,
        'key': key,
        'uniapp': uniapp,
        'random_number': Math.random(),
        'hash': hash,
        'img': img,
        'inr_amount': inrAmount
      },
      'member'
    )
// // 用户支付
// export const pay =
//   (paySn, payType, data, key, uniapp = 0, hash, img) =>
//     requestRaw(
//       env.SITE_URL + '/index.php?s=api/Memberpayment/' + payType + '/pay_sn/' + paySn + '/password/' + data.password + '/rcb_pay/' + data.rcb_pay + '/pd_pay/' + data.pd_pay + '/payment_code/' + data.payment_code + '/key/' + key + '/uniapp/' + uniapp + '/random_number/' + Math.random() + '/hash/' + hash + '/img=' + img + '/'
//     )

// 获取支付方式列表
export const getPaymentList =
  (payment_platform = '', payment_code = '') =>
    requestApi(
      '/Memberpayment/payment_list',
      'POST',
      {
        payment_platform: payment_platform,
        payment_code: payment_code
      },
      'member'
    )